import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';

import { Formik, Form } from 'formik';

import { TIME_AFTER_MESSAGE } from '../../libraries/constants';

import {
  SAVE_EDITION_BUTTON,
  CREATION_TITLE,
  EDITION_TITLE,
  BEFORE_CREATED,
  INCORRECT_VALUE,
  CHANGES_SUCCESSFULL
} from '../../libraries/texts';
import { useLoadingBar } from '../../libraries/contexts';
import { reduceSpaces, sleep } from '../../libraries/utils';

const EditForm = mapHooksToProps => WrappedComponent => {
  return props => {
    const {
      classes,
      match: {
        params: { id }
      }
    } = props;

    const customProps = { match: props.match };
    const [, setLoading] = useLoadingBar();
    const {
      getErrors,
      service,
      wrapperInformation,
      errorWrapper,
      initialWrapperData,
      containerClass = false,
      buttonClass = false,
      buttonName = SAVE_EDITION_BUTTON,
      finalMessageAfterRequest = CHANGES_SUCCESSFULL
    } = mapHooksToProps(props);

    const [initialValues, setInitialValues] = useState({});
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [sendForm, setSetForm] = useState(false);

    const isValidFormComponent = isValid => {
      setSetForm(isValid);
    };

    const isValidForm = (errors, touched) =>
      Object.values(errors).length === 0 && Object.values(touched).length !== 0;

    const onSubmit = async (values, { setFieldError }) => {
      try {
        setLoading({ principalLoading: true });
        let newValues = Object.entries(values).reduce(reduceSpaces, {});
        newValues = wrapperInformation ? wrapperInformation(newValues) : newValues;
        id ? await service.put(id, newValues) : await service.post(newValues);
        setLoading({ principalLoading: false });
        setSetForm(true);
        if (finalMessageAfterRequest) {
          setMessage(finalMessageAfterRequest);
          await sleep(TIME_AFTER_MESSAGE);
        }
        setSetForm(false);
        if (service.redirectListPage) {
          return window.location.assign(service.redirectListPage());
        }
        props.history.push(service.listPage());
      } catch (err) {
        setLoading({ principalLoading: false });
        setSetForm(false);
        const { errors } = err;
        if (errors) {
          errors.map(elem => {
            const message = elem.includes('duplicate') ? BEFORE_CREATED : INCORRECT_VALUE;
            const stringSearch = elem.includes('duplicate') ? el => `index: ${el}` : el => `${el}`;
            let val = Object.keys(values).filter(el => elem.includes(stringSearch(el)));
            val = val.length > 0 ? val[0] : false;
            if (val) {
              setFieldError(val, message);
            }
            return err;
          });
        }
        if (errorWrapper) {
          errorWrapper({ setFieldError })(errors);
        }
      }
    };

    const getRequests = async () => {
      setLoading({ principalLoading: true });
      try {
        let data = await service.get(id);
        data = initialWrapperData ? initialWrapperData(data) : data;
        await setInitialValues(data);
        setShowForm(true);
      } catch (err) {}

      setLoading({ principalLoading: false });
    };
    useEffect(() => {
      if (id) {
        setTitle(EDITION_TITLE);
        getRequests();
      } else {
        setTitle(CREATION_TITLE);
        setShowForm(true);
      }
    }, []);

    return (
      <React.Fragment>
        <Card className={classNames(classes.card, { [containerClass]: containerClass })}>
          {showForm ? (
            <Formik initialValues={initialValues} validate={getErrors} onSubmit={onSubmit}>
              {formProps => {
                const { errors, touched } = formProps;
                return (
                  <React.Fragment>
                    <Form className={classes.formSubscriptor}>
                      <WrappedComponent
                        {...formProps}
                        {...customProps}
                        title={title}
                        isValidFormComponent={isValidFormComponent}
                      />
                      <CardActions
                        className={classNames(classes.actions, {
                          [buttonClass]: buttonClass
                        })}
                        disableActionSpacing
                      >
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          disabled={!sendForm ? !isValidForm(errors, touched) : sendForm}
                        >
                          {buttonName}
                        </Button>
                        {!message ? (
                          ''
                        ) : (
                          <Typography variant="small" color="primary" className={classes.message}>
                            {message}
                          </Typography>
                        )}
                      </CardActions>
                    </Form>
                  </React.Fragment>
                );
              }}
            </Formik>
          ) : (
            ''
          )}
        </Card>
      </React.Fragment>
    );
  };
};

export default EditForm;
